// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import Img, { FixedObject } from "gatsby-image"
import Slider from "react-slick"
import * as styles from "./styles.module.scss"
import "slick-carousel/slick/slick.scss"

interface TenetProps {
  title: string
  image: FixedObject
  alt: string
  children: any
}

export const Tenet: React.FC<TenetProps> = ({
  title,
  image,
  alt,
  children,
}: TenetProps) => {
  return (
    <div className={styles.tenetItem}>
      <div className={styles.tenetItemIcon}>
        <Img fixed={image} alt={alt} />
      </div>
      <h3 className={styles.tenetItemTitle}>{title}</h3>
      <p>{children}</p>
    </div>
  )
}

interface Props {
  children: any
}

const TenetSlider: React.FC<Props> = ({ children }: Props) => {
  const settings = {
    className: styles.tenetSlider,
    arrows: false,
    infinite: false,
    autoplay: false,
    fadeIn: false,
    slidesToShow: children.length,
    slidesToScroll: children.length,
    responsive: [
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return <Slider {...settings}>{children}</Slider>
}

export default TenetSlider
